// extracted by mini-css-extract-plugin
export default {"title":"CategoryTitle_title__DMLjq"};